"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddedFile = void 0;
var _react = _interopRequireDefault(require("react"));
var _ActionLink = require("b2b-components/theme/components/ActionLink");
var _classnames = _interopRequireDefault(require("classnames"));
require("./AddedFile.scss");
var AddedFile = function AddedFile(_ref) {
  var className = _ref.className,
    fileName = _ref.fileName,
    onRemoveClick = _ref.onRemoveClick,
    text = _ref.text;
  var rootClassName = (0, _classnames["default"])('cds-AddedFile', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-AddedFile-Name"
  }, fileName), /*#__PURE__*/_react["default"].createElement(_ActionLink.ActionLink, {
    className: "cds-AddedFile-Button",
    iconName: _ActionLink.ACTION_LINK_ICON_NAME.close,
    iconSize: _ActionLink.ACTION_LINK_ICON_SIZE.small,
    onClick: onRemoveClick
  }, text.remove));
};
exports.AddedFile = AddedFile;